<div *ngIf="apiService.supplierRole" class="unauthorized-message">
  {{apiService.Notautorized}}
</div>
<div *ngIf="!apiService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 no-bottom-margin">
    <div class="d-flex align-items-center m-0 pb-1">


        <div class="col-4 pl-0">
          <button type="button" class="btn btn-green btn-custom btn-blue mr-2 btn-ht" [routerLink]="['/bvd']" *ngIf="showForConsult">
            <mat-icon svgIcon="add-2" class="img-btn img-btn-md"></mat-icon><span class="float-right">Import a Supplier</span>
          </button>
        </div>

        <div class="center col-4 text-center"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png" class="brand-logo" alt="edit"></div>
        <div class="col-4 text-right">
          <div> <app-helpsection></app-helpsection></div>

        </div>
    </div>

  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 search-panel">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <h4 class="title">SEARCH</h4>
      </div>
      <div class="col col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 text-right">
        <button class="btn btn-custom btn-darkred px-4 mr-2" *ngIf="roleVariableHide" type="button" data-toggle="modal" data-target="#openFactoriesModal" (click)="FactoriesCodedisp()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (FactoriesCodedisp())">
          Factories
        </button>
        <button type="button" class="btn btn-custom btn-darkred create-site-button" *ngIf="roleVariableHide" data-toggle="modal"
          data-target="#createSitesModalPopup" (click)="CreateSitesFirst()">
          <mat-icon class="create-site-icon" svgIcon="add-2"></mat-icon> <span class="create-site-label float-right"> Create Site </span>
        </button>
      </div>
    </div>
    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control">Sites name
        </label>
        <p class="pr-4 m-0">
          <div class="form-control form-control-sm matformheight">
            <form class="autocomplete-form">
              <mat-form-field class="autocomplete-field">
                <input class="autocomplete-input" matInput aria-label="State" [matAutocomplete]="autoc" (keyup)="onItemKey($event)" (keydown.enter)="getChangeHandler(); $event.preventDefault()" (keydown)="$event.key !== 'Enter' && resetOtherFields('name',$event)" [formControl]="delayNameResponse">
                <mat-autocomplete id="option" #autoc="matAutocomplete" class="custom-autocomplete" (optionSelected)="onIdentivalueSelect($event.option.value, 'name')">
                  <ng-container *ngIf="siteNamesDropDown.length > 0 && enterKey; else noResults">
                    <mat-option class="autocomplete-option" *ngFor="let value of siteNamesDropDown" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults>
                    <mat-option class="noResults" disabled *ngIf="sitesNameModel.length >= 5 && !autoload && enterKey">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetSelectedFields('identifierValueModel')">X</button></small>
              <small class="float-right search-close-btn" *ngIf="autoload"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            </form>
          </div>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control">Country
        </label>
        <p class="pr-4 m-0">
          <div class="form-control form-control-sm matformheight">
            <form class="autocomplete-form">
              <mat-form-field class="autocomplete-field">
                <input class="country-search-input" [matAutocomplete]="autoc1" matInput aria-label="State" (input)="onCountryInput($event, delaySiteSearchResCountry)" (keydown.enter)="getChangeHandler(); $event.preventDefault()" (keydown)="$event.key !== 'Enter' && resetOtherFields('name',$event)" (keyup)="onItemKey($event)" [formControl]="delaySiteSearchResCountry">
                <mat-autocomplete #autoc1="matAutocomplete" class="custom-autocomplete" (optionSelected)="siteSearchonCountryeSelect($event.option.value)">
                  <ng-container *ngIf="siteSearchCountryDatas.length > 0 && enterKey; else noResults1">
                    <mat-option class="autocomplete-option" *ngFor="let value of siteSearchCountryDatas" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults1>
                    <mat-option class="noResults" disabled *ngIf="siteSearchCountryModel.length >= 2 && !countryLoad && enterKey">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetSelectedFields('country')">X</button></small>
              <small class="float-right search-close-btn" *ngIf="countryLoad"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            </form>
            </div>
        <button type="button" class="float-right info-btn" title="info" data-toggle="modal" data-target="#dispCountryInfo" (click)="countryInfoModel()">
          <mat-icon svgIcon="info" class="country-info-icon"></mat-icon>
        </button>
      </div>
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <label class="label-control">City
        </label>
        <p class="pr-4 m-0">
          <div class="form-control form-control-1 form-control-sm matformheight" [ngClass]="{'disabled-div': siteSearchCityDisable}">
            <form class="autocomplete-form">
              <mat-form-field class="autocomplete-field">
                <input class="autocomplete-input" matInput aria-label="State" [matAutocomplete]="autoc2" (keyup)="onItemKey($event)" (keydown.enter)="getChangeHandler(); $event.preventDefault()" (keydown)="$event.key !== 'Enter' && resetOtherFields('name',$event)" [formControl]="delaySiteSearchResCity">
                <mat-autocomplete #autoc2="matAutocomplete" (optionSelected)="siteSearchonCityeSelect($event.option.value)" class="custom-autocomplete">
                  <ng-container *ngIf="sitesSearchCityDropDown.length > 0 && enterKey; else noResults2">
                    <mat-option class="autocomplete-option" *ngFor="let value of sitesSearchCityDropDown" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults2>
                    <mat-option class="noResults" disabled *ngIf="siteSearchCityModel.length >= 2 && !cityLoad && enterKey">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetSelectedFields('city')">X</button></small>
              <small class="float-right search-close-btn" *ngIf="cityLoad"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            </form>
          </div>
      </div>
    </div>

    <div class="row m-0 ml-3 align-center">
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
        <span class="px-2 font-weight-bold">OR</span>
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
    </div>


    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Identifier Type</mat-label>
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="identifierTypeModel" (selectionChange)="selectChangeHandler($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
            <mat-option value="RAFT_CODE">Site code (RAFT)</mat-option>
            <mat-option value="SAER_CODE">Site code (SAER)</mat-option>
            <mat-option value="AP_LATAM_CODE">Site code (LATAM)</mat-option>
            <mat-option value="AP_C2B_CODE">Site code (C2B)</mat-option>
            <mat-option value="AP_RNAIPL_CODE">Site code (RNAIPL)</mat-option>
            <mat-option value="access-points">Qualifier ID</mat-option>
            <mat-option value="allianceSiteId">Site ID</mat-option>
            <mat-option value="BVDID">BvD ID</mat-option>
            <mat-option value="TaxID">Tax ID</mat-option>
            <mat-option value="site_status">Site Status</mat-option>
            <mat-option value="workflow_status">Workflow Status</mat-option>
          </mat-select>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
        <label class="label-control">Identifier Value
        </label>
        <p class="pr-4 m-0">
          <div class="form-control form-control-1 form-control-sm matformheight" *ngIf="!statusDropdown && !workflowDropdown">
            <form class="autocomplete-form">
              <mat-form-field class="autocomplete-field">
                <input class="autocomplete-input" matInput aria-label="State" (keyup)="onItemKey($event)" (keydown.enter)="getChangeHandler(); $event.preventDefault()" (keydown)="$event.key !== 'Enter' && resetOtherFields('identifiers',$event)" [matAutocomplete]="autoc3" [formControl]="delayResponse">
                <mat-autocomplete #autoc3="matAutocomplete" (optionSelected)="onIdentivalueSelect($event.option.value,'id')" class="custom-autocomplete">
                  <ng-container *ngIf="sitesiDvalDropDown1.length > 0 && enterKey; else noResults3">
                    <mat-option class="autocomplete-option" *ngFor="let value of sitesiDvalDropDown1" [value]="value">
                      <span>{{ value }}</span>
                    </mat-option>
                  </ng-container>
                  <ng-template #noResults3>
                    <mat-option class="noResults" disabled *ngIf="identifierValueModel.length >= minSearchLengthIdentifier && !identifierLoad && enterKey">
                      <span>No results</span>
                    </mat-option>
                  </ng-template>
                </mat-autocomplete>
              </mat-form-field>
              <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetSelectedFields('sitesNameModellabel')">X</button></small>
              <small class="float-right search-close-btn" *ngIf="identifierLoad"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
            </form>
          </div>

        <div class="pr-4 m-0" *ngIf="statusDropdown && !workflowDropdown">
            <mat-select [(ngModel)]="selectedStatusModel" (change)="selectedStatusChange($event)" class="form-control form-control-sm dropdown-select" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option value="PENDING">Inactive</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="ARCHIVED">Archived</mat-option>
              <mat-option value="CREATED">Identified</mat-option>
            </mat-select>
        </div>
        <div class="pr-4 m-0" *ngIf="workflowDropdown && !statusDropdown">
            <mat-select [(ngModel)]="selectedWorkflowStatusModel" class="form-control form-control-sm dropdown-select" panelClass="dropdown-panel" [disableOptionCentering]="true">
              <mat-option *ngFor="let status of WorkflowStatusAll" [value]="status">{{status}}</mat-option>
            </mat-select>
        </div>
      </div>


      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions" *ngIf="!roleVariableHide">
        <mat-label class="label-control hidden"> &nbsp; </mat-label>
        <button type="button" class="btn btn-custom btn-link" (click)="resetSelectedFields('all')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('all'))"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="getChangeHandler()"> Search </button>
      </div>
    </div>

    <div class="row m-0 align-center search-actions-row">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions" *ngIf="roleVariableHide">
        <mat-label class="label-control hidden"> &nbsp; </mat-label>
          <button type="button" class="btn btn-custom btn-link" (click)="resetSelectedFields('all')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (resetSelectedFields('all'))"> Clear All </button>
          <button type="button" class="btn btn-custom btn-custom-lg btn-blue" (click)="getChangeHandler()"> Search </button>
      </div>
    </div>
  </section>


  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS
          <span *ngIf="listFlag==true && sitesData && sitesData.length>0">({{pagedTotalItem}})
          </span>
        </h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button" class="btn btn-custom btn-darkred float-right btn-ht export-button" (click)="ExportTOExcel()" *ngIf="roleVariableHide" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (ExportTOExcel())">
          <mat-icon svgIcon="download" class="thick-icon export-icon" ></mat-icon><span class="float-right"> Export </span>
        </button>
      </div>
    </div>



    <div class="row m-0">
      <div class="table-responsive mt-3 ">
        <div [ngClass]="{ 'fixTableHead' :listFlag == true, 'fixTableFoot' :listFlag == true }">
          <table class="table table-sm m-0 results-table" id="excelTableLogg">
            <thead>
              <tr>
                <th class="results-name-header sortDecorationunderline"  (click)="sort('name')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('name'))">
                      Site Name
                </th>
                <th class="results-status-header sortDecorationunderline" (click)="sort('activeStatus')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('activeStatus'))">
                      Site Status
                      <div>Workflow Status</div>
                </th>
                <th class="results-site-id-header">
                    Site ID
                </th>
                <th class="results-bvd-header" *ngIf="showForSupplier && showForConsult">
                  BvD ID
                </th>
                <th class="results-c2b-header">
                  C2B
                </th>
                <th class="results-legacy-header">
                  Legacy Codes
                </th>
                <th class="results-address-header sortDecorationunderline" (click)="sort('countryName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('countryName'))">
                      Address
                </th>
                <th class="results-company-header">
                  Company
                </th>
                <th class="results-qualifiers-header">Qualifiers
                  <span>
                    <div class="dropdown inline-dropdown">
                      <span class="edit" type="button" id="dropdownMenuButton" (click)="showDropdownQualifiers()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (showDropdownQualifiers())">
                        <mat-icon *ngIf="filteredStatushighlight" src="filter" class="img-btn img-btn-sm"></mat-icon>
                        <mat-icon *ngIf="!filteredStatushighlight" src="filter" class="img-btn img-btn-sm"></mat-icon>
                      </span>
                    </div>
                  </span>
                  <div *ngIf="showFilterQualifiers" class="qualifiers-filter">
                    <ng-container>
                      <ul class="row m-0 nav list-view p-0 pt-1 qualifiers-filter-list">
                        <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 qualifiers-filter-item" *ngFor="let qua of qualifiersCount">
                          <div>
                            <input type="checkbox" id="{{qua}}" (click)="setCheckboxVal(qua)" value="{{qua}}" class="edit checkboxAt" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (setCheckboxVal(qua))">
                            <mat-icon class="qualifer-icons qualifier-filter-icon pr-0 py-0 pl-3" svgIcon="{{sortedQualifiers[qua]}}" alt="" title="{{qualifierTypesText[qua]}}"></mat-icon>
                            <span class="pl-3">
                              {{qualifierTypesText[qua]}}
                            </span>
                          </div>
                        </li>
                      </ul>
                      <div class="modal-footer py-0 pr-0 border-0 mt-2">
                        <button type="button" class="btn btn-custom btn-link qualifiers-clear-button" (click)="showDropdownQualifiers('close')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (showDropdownQualifiers('close'))">Clear</button>
                        <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="filterQualifiers()">OK</button>
                      </div>
                    </ng-container>
                  </div>
                </th>
              </tr>
            </thead>

            <tbody *ngIf="sitesData && sitesData.length>=0 && listFlag==true" #customLoadingTemplate2>
              <tr *ngFor="let sitesData of sitesData | orderBy: key:reverse; let i = index">
                <ng-container *ngIf="sitesData.filterTrue==true">
                  <td *ngIf="siteAssignmentData[sitesData.rowId]" class="font-weight-bold "><a class="label-darkblue" [routerLink]="['/site-details',sitesData.rowId,siteAssignmentData[sitesData.rowId].businessEntityCompanyId]">{{sitesData ? sitesData.name : ''}}</a></td>
                  <td *ngIf="!siteAssignmentData[sitesData.rowId]" class="font-weight-bold"><a class="label-darkblue" [routerLink]="['/site-details',sitesData.rowId,undefined]">{{sitesData ? sitesData.name : ''}}</a></td>
                  <td>
                    <span class="group-status status-badge px-3 py-1" [class.status-inactive]="sitesData?.activeStatus?.toLowerCase() === 'pending'" [class.status-identified]="sitesData?.activeStatus?.toLowerCase() === 'created'" [class.status-active]="sitesData?.activeStatus?.toLowerCase() === 'active'" [class.status-archived]="sitesData?.activeStatus?.toLowerCase() === 'archived'">
                      {{sitesData ? sitesData.activeStatus.replace("CREATED","Identified").replace("PENDING","Inactive").replace("ACTIVE","Active") : ''}}
                    </span>
                    <span class="group-status status-badge workflow-status-badge px-3 py-1"
                      *ngIf="sitesData"
                      [ngStyle]="{'background' : workflowStatusColors[sitesData.workflowStatus || sitesData.workflowStatusCode || 'NotStarted'] || '#D8C4A0','min-width': '82px','float': 'left','clear': 'both','margin-top': '6px' }">
                      {{sitesData.workflowStatus || sitesData.workflowStatusCode || 'NotStarted'}}
                    </span>
                  </td>
                  <td>
                    <span class="font-weight-bold">
                      {{sitesData.identifier}}
                    </span>
                  </td>
                  <td *ngIf="showForSupplier && showForConsult"><span *ngIf="BvDIdData && siteAssignmentData[sitesData.rowId]">{{BvDIdData[siteAssignmentData[sitesData.rowId].businessEntityId] ? BvDIdData[siteAssignmentData[sitesData.rowId].businessEntityId] : ''}}</span></td>
                  <td class="codes-cell">
                    <span *ngIf="siteC2bCodeValOnRowId[sitesData.identifier]">
                      <ul class="row m-0 nav list-view p-0" *ngFor="let c2b of siteC2bCodeValOnRowId[sitesData.identifier]">
                        <li class="list-view-item">{{c2b}}</li>
                      </ul>
                    </span>
                  </td>
                  <td class="legacy-codes-cell">
                    <span *ngIf="siteRaftCodeValOnRowId[sitesData.identifier]">
                      <ul class="row m-0 nav list-view p-0" *ngFor="let rafts of siteRaftCodeValOnRowId[sitesData.identifier]">
                        <li class="list-view-item"><b>R:</b> {{rafts}}</li>
                      </ul>
                      <!-- {{siteRaftCodeValOnRowId[sitesData.identifier] ? siteRaftCodeValOnRowId[sitesData.identifier] : ''}} -->
                    </span>

                    <span *ngIf="siteSaerCodeValOnRowId[sitesData.identifier]">
                      <ul class="row m-0 nav list-view p-0" *ngFor="let saer of siteSaerCodeValOnRowId[sitesData.identifier]">
                        <li class="list-view-item"><b>S:</b> {{saer}}</li>
                      </ul>
                    </span>

                    <span *ngIf="siteLatamCodeValOnRowId[sitesData.identifier]">
                      <ul class="row m-0 nav list-view p-0" *ngFor="let latam of siteLatamCodeValOnRowId[sitesData.identifier]">
                        <li class="list-view-item"><b>L:</b> {{latam}}</li>
                      </ul>
                    </span>

                    <span *ngIf="siteRnaiplCodeValOnRowId[sitesData.identifier]">
                      <ul class="row m-0 nav list-view p-0" *ngFor="let rnaipl of siteRnaiplCodeValOnRowId[sitesData.identifier]">
                        <li class="list-view-item"><b>I:</b> {{rnaipl}}</li>
                      </ul>
                    </span>
                  </td>
                  <td>
                    <span class="font-italic address-details">
                      {{acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]] ? (acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].wayNumber ? acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].wayNumber + ',' : '') : ''}}
                      {{acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]] ? (acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].streetName ? acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].streetName + (acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].additionalInformation ? ',' : '') : '') : ''}}
                      <div>
                        {{acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]] ? acpAddressDetOnRows[accessPointIdOnAddress[siteRowIdsOnMainEntrance[sitesData.rowId]]].additionalInformation : ''}}
                      </div>
                    </span>
                    <div class="city-name font-weight-bold">
                      {{sitesData ? sitesData.cityName : ''}}
                    </div>
                    <div class="font-weight-bold">{{sitesData ? sitesData.countryName : ''}}</div>
                  </td>
                  <td><a class="font-weight-bold label-darkblue" [routerLink]="['/company-details/', siteAssignmentData[sitesData.rowId]?.businessEntityCompanyId]" *ngIf="siteAssignmentData[sitesData.rowId]"><span>{{sitesData ? siteAssignmentData[sitesData.rowId].businessEntityCompanyLegalName : ''}}</span></a></td>
                  <td *ngIf="!sitesData"></td>
                  <td class="qualifiers-cell">
                    <div class="row" *ngIf="accessPointDataNew.length>0" >
                    <span *ngFor="let some of sortedQualifiers | keyvalue : returnZero">
                      <div class="col qualifier-column" *ngIf="accessPointDataNew[sitesData.rowId] && accessPointDataNew[sitesData.rowId][some.key]">
                        <div class="icon-container">
                          <span class="main-icon">
                          <mat-icon class="qualifier-icon" title="{{accessPointDataNew[sitesData.rowId][some.key] ? qualifierTypesText[some.key] : ''}}" data-toggle="tooltip"
                          svgIcon="{{accessPointDataNew[sitesData.rowId][some.key] ? some.value : ''}}"></mat-icon>
                          </span>
                          <span class="superscript-icon" [style.background-color]="qualifierColors[some.key]" *ngIf="accessPointDataNew[sitesData.rowId] && accessPointDataNew[sitesData.rowId][some.key] && accessPointDataNew[sitesData.rowId][some.key] != 1">
                          {{accessPointDataNew[sitesData.rowId][some.key]}}
                          </span>
                        </div>
                      </div>
                    </span>
                    </div>
                  </td>
                </ng-container>
              </tr>
            </tbody>
            <tbody *ngIf="listFlag == false || sitesData.length==0">
              <tr>
                <td colspan="11" *ngIf="showForSupplier && showForConsult" class="font-weight-bold label-darkblue text-center"> No Results</td>
                <td colspan="10" *ngIf="!(showForSupplier && showForConsult)" class="font-weight-bold label-darkblue text-center"> No Results</td>
              </tr>
            </tbody>
            <tfoot *ngIf="sitesData.length > 0 && loading == false && listFlag == true">
            <tr>
              <td colspan="12">
                    <!-- pager -->
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="classifyPagination(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (classifyPagination(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="classifyPagination(pager.currentPage - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (classifyPagination(pager.currentPage - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="classifyPagination(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (classifyPagination(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="classifyPagination(pager.currentPage + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (classifyPagination(pager.currentPage + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="classifyPagination(pager.totalPages)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (classifyPagination(pager.totalPages))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
            <!-- Spinner -->
          </table>
        </div>
      </div>
    </div>
  </section>

</div>
<!--Create Sites Model Start here-->
<div class="modal fade" id="createSitesModalPopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Create Site
          <button type="button" class="close" id="closeSCBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Site Name<span class="element_astrick">*</span> </label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="siteNameFieldModel"
              (ngModelChange)="siteNameFieldModel = $event.toUpperCase()"
              (keyup)="checkForRegExSitesCreation($event,siteNameFieldModel,'siteNameFieldModel')"
              maxlength="100" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear no-border clear-button"
                (click)="resetCreateSiteFields('siteNameFieldModel')">×</button></span>
            <span class="validation-error" *ngIf="siteNameFieldModelError==true">Please enter site name</span>
            <span class="validation-error" *ngIf="siteNameModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Site Short Name<span class="element_astrick">*</span> </label>
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="siteShortNameFieldModel"
              (ngModelChange)="siteShortNameFieldModel = $event.toUpperCase()"
              (keyup)="checkForRegExSiteShortCreation($event,siteShortNameFieldModel,'siteShortNameFieldModel')"
               maxlength="100" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button
                class="ng-clear no-border clear-button"
                (click)="resetCreateSiteFields('siteShortNameFieldModel')">×</button>
            </span>
            <span class="validation-error" *ngIf="siteShortNameFieldModelError==true">Please enter site short name</span>
            <span class="validation-error" *ngIf="siteShortNameModelRegExError==true">A-Z 0-9 space</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Country<span class="element_astrick">*</span> </label>
            <div class="form-control form-control-sm matformheight">
              <form class="autocomplete-form">
                <mat-form-field class="autocomplete-field-createSite">
                  <input class="country-autocomplete-input" matInput aria-label="State" (input)="onCountryInput($event, delayResCountry)" [matAutocomplete]="auto3" [formControl]="delayResCountry">
                  <mat-autocomplete #auto3="matAutocomplete" (optionSelected)="onCountryeSelect($event.option.value)" class="custom-autocomplete">
                    <ng-container *ngIf="CaptCountry.length > 0; else noResults4">
                      <mat-option class="autocomplete-option-createSite" *ngFor="let value of CaptCountry" [value]="value">
                        <span>{{ value }}</span>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults4>
                      <mat-option class="noResults" disabled *ngIf="siteCountryModel.length >= 2 && !countryLoad1">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetCreateSiteFields('siteCountryModel')">X</button></small>
                <small class="float-right search-close-btn" *ngIf="countryLoad1"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
              </form>
            </div>
              <span class="validation-error" *ngIf="siteCountryModelError==true">Please select country name</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">City<span class="element_astrick">*</span></label>
            <div class="form-control form-control-sm matformheight" [ngClass]="{'disabled-div': cityDisable}">
              <form class="autocomplete-form">
                <mat-form-field class="autocomplete-field">
                  <input class="autocomplete-input" matInput aria-label="State" [matAutocomplete]="auto4" [formControl]="delayResCity">
                  <mat-autocomplete #auto4="matAutocomplete" class="custom-autocomplete" [panelWidth]="'750px'" (optionSelected)="onCityeSelect($event.option.value)">
                    <ng-container *ngIf="CaptCity.length > 0; else noResults5">
                      <mat-option *ngFor="let value of CaptCity" [value]="value.name">
                        <div class="table-row">
                          <div class="cell name">{{ value.name }}</div>
                          <div class="cell lat">{{ value.latitude }}</div>
                          <div class="cell long">{{ value.longitude }}</div>
                          <div class="cell zone">{{ value.adminZoneCode }}</div>
                          <div class="cell zone-name">{{ value.adminZoneName }}</div>
                          <div class="cell zone2">{{ value.adminZoneCode2 }}</div>
                          <div class="cell zone-name2">{{ value.adminZoneName2 }}</div>
                        </div>
                      </mat-option>
                    </ng-container>
                    <ng-template #noResults5>
                      <mat-option class="noResults" disabled *ngIf="siteCityModel.length >= 2 && !cityLoad1">
                        <span>No results</span>
                      </mat-option>
                    </ng-template>
                  </mat-autocomplete>
                </mat-form-field>
                <small class="float-right search-close-btn" title="Clear"><button class="no-border" (click)="resetCreateSiteFields('siteCityModel')">X</button></small>
                <small class="float-right search-close-btn" *ngIf="cityLoad1"><img src="assets/images/loading.gif" class="loadingheight" alt="Updating..."></small>
              </form>
              <span class="validation-error" *ngIf="siteCityModelError==true">Please select city name</span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <label class="label-control">N°
            </label>
            <div>
              <input class="form-control form-control-sm form-control-paddings address-input"
                [(ngModel)]="wayNumberModel"  type="text" (keyup)="checkForRegExSitesCreation($event,wayNumberModel,'wayNumberModel')"
                (ngModelChange)="wayNumberModel = $event.toUpperCase()"
                maxlength="9" />
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                  class="ng-clear no-border" (click)="resetCreateSiteFields('wayNumberModel')">×</button></span>
              <span class="validation-error" *ngIf="wayNumberModelRegExError==true">A-Z 0-9 space () . , - /</span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
            <label class="label-control">Street<span class="element_astrick">*</span>
            </label>
            <div>
              <input class="form-control form-control-sm form-control-paddings address-input"
                [(ngModel)]="siteStreetModel"  type="text" (keyup)="checkForRegExSitesCreation($event,siteStreetModel,'siteStreetModel')"
                (ngModelChange)="siteStreetModel = $event.toUpperCase()" maxlength="35"/>
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                  class="ng-clear no-border clear-button"
                  (click)="resetCreateSiteFields('siteStreetModel')">×</button></span>
              <span class="validation-error" *ngIf="siteStreetModelError==true">Please enter street</span>
              <span class="validation-error" *ngIf="siteStreetModelRegExError==true">A-Z 0-9 space () . , - /</span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Additional Address information
            </label>
            <div>
              <div>
                <input class="form-control form-control-sm form-control-paddings address-input"
                  type="text" [(ngModel)]="siteAdditionalAddress"
                  maxlength="35"
                  (ngModelChange)="siteAdditionalAddress = $event.toUpperCase()"
                  (keyup)="checkForRegExSitesCreation($event,siteAdditionalAddress,'siteAdditionalAddress')"/>
                  <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear no-border clear-button"  (click)="resetCreateSiteFields('siteAdditionalAddress')">×</button></span>
              </div>
              <span class="validation-error" *ngIf="siteAdditionalAddressRegExError==true">A-Z 0-9 space () . , - /</span>
              <div>
                <input class="form-control form-control-sm form-control-paddings address-input"
                  type="text" [(ngModel)]="siteAdditionalAddressInfo"
                  maxlength="35"
                  (ngModelChange)="siteAdditionalAddressInfo = $event.toUpperCase()"
                  (keyup)="checkForRegExSitesCreation($event,siteAdditionalAddressInfo,'siteAdditionalAddressInfo')" />
                  <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button class="ng-clear no-border clear-button"  (click)="resetCreateSiteFields('siteAdditionalAddressInfo')">×</button></span>
              </div>
              <span class="validation-error" *ngIf="siteAdditionalAddressInfoRegExError==true">A-Z 0-9 space () . , - /</span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Postal Code</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="sitePostcodedModel" (keyup)="checkForRegExSitesCreation($event,sitePostcodedModel,'sitePostcodedModel')"
            (ngModelChange)="sitePostcodedModel = $event.toUpperCase()" maxlength="9" />
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all"><button
                class="ng-clear no-border clear-button"
                (click)="resetCreateSiteFields('sitePostcodedModel')">×</button></span>
            <span class="validation-error" *ngIf="sitePostcodeModelError==true">Please enter Postal Code</span>
            <span class="validation-error" *ngIf="sitePostcodedModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <label class="label-control">Territorial Division </label>
            <input
            class="address-input"
            type="text"
            class="form-control form-control-sm"
            [(ngModel)]="territorialDivisionModel"
            (keyup)="checkForRegExSitesCreation($event,territorialDivisionModel,'territorialDivisionModel')"
            (ngModelChange)="territorialDivisionModel = $event.toUpperCase()" maxlength="35"/>
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button class="ng-clear no-border clear-button"
                (click)="resetCreateSiteFields('territorialDivisionModel')">×</button>
            </span>
            <span class="validation-error" *ngIf="territorialDivisionModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <label class="label-control">Latitude :</label>
            <p class="coordinate-row">
              <span class="coordinate-degrees">
                <input id="latitude_degres" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latDegVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="latitude_degres">&deg;</label>&nbsp;
              <span class="coordinate-degrees">
                <input id="latitude_minutes" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latMinVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="latitude_minutes">'</label>&nbsp;
              <span class="coordinate-seconds">
                <input id="latitude_secondes" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="latSecVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="latitude_secondes">''</label>&nbsp;
              <span class="coordinate-direction">
              <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="northSouthModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="North">N</mat-option>
                  <mat-option value="South">S</mat-option>
              </mat-select>
              </span>
            </p>
          </div>
          <div class="col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pr-0">
            <label class="label-control">Longitude :</label>
            <p class="coordinate-row">
              <span class="coordinate-degrees">
                <input id="longitude_degres" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longDegVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="longitude_degres">&deg;</label>&nbsp;
              <span class="coordinate-degrees">
                <input id="longitude_minutes" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longMinVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="longitude_minutes">'</label>&nbsp;
              <span class="coordinate-seconds">
                <input id="longitude_secondes" type="text" (keyup)="dmsversdd()" class="form-control form-control-sm form-control-paddings pr-1" [(ngModel)]="longSecVal">
              </span>
              <label class="font-weight-bold coordinate-symbol" for="longitude_secondes">''</label>&nbsp;
              <span class="coordinate-direction">
              <mat-select class="form-control form-control-sm p-0 dropdown-select"  [(ngModel)]="eastWestModel" (ngModelChange)="dmsversdd()" panelClass="dropdown-panel" [disableOptionCentering]="true">
                  <mat-option value="North">E</mat-option>
                  <mat-option value="South">W</mat-option>
              </mat-select>
              </span>
            </p>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <label class="label-control">Latitude</label>
            <div>
              <input class="form-control form-control-sm" [(ngModel)]="gpsValueModelLat" (keyup)="ddversdms()" type="text"/>
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                <button class="ng-clear no-border clear-button" (click)="resetCreateSiteFields('gpslat')">×</button>
              </span>
            </div>
          </div>

          <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <label class="label-control">Longitude</label>
            <div>
              <input class="form-control form-control-sm" [(ngModel)]="gpsValueModelLon"  (keyup)="ddversdms()" type="text"/>
              <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
                <button class="ng-clear no-border clear-button" (click)="resetCreateSiteFields('gpslon')">×</button>
              </span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0 modal-footer-section">
          <button type="button"  class="btn btn-custom btn-blue" (click)="copyGpsdata()" *ngIf="roleVariableHide ==true && gpsValueModelLat==''&& gpsValueModelLon==''" >
            Copy city Gps data
          </button>
        <div class="modal-footer-actions">
       <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
       <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveSitesDetails()" [disabled]="disableSiteCreateBtn==true">
         <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right"> {{saveDatas}}</span>
       </button>
      </div>
     </section>
      </div>
    </div>
  </div>
</div>
<!--Create Sites Model End here-->

<!-- START site assignment batch -->
<div class="modal fade" id="showSiteAssnBatch" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Site Assignment Batch
          <button type="button" class="close" id="closeSiteAssnBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="showDownloadLog==false">&nbsp;
              <span [innerHtml]="aliasTextDisp">
              </span>
            </div>
            <div class="py-2" *ngIf="showDownloadLog==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFile()">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-orange">Processing page:</span>&nbsp;<span class="page-number">{{pageBatchNo}}</span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" (click)="changeStopBatch()"> Stop </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END Site assignment batch -->

<!-- Restart from last page for site assignment -->

<!-- START site assignment batch -->
<div class="modal fade" id="showAlreadyRunBatch" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Site Assignment Batch
          <button type="button" class="close" id="closeSiteAssnBatchExistDia" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">&nbsp;
              <span>
                Previously the batch was stopped at page : <span class="label-orange font-weight-bold">{{siteBatchPageHolder}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button class="btn btn-custom btn-blue batch-continue-button" data-dismiss="modal" (click)="siteAssnBatchFn(siteBatchPageHolder,'continue',20)"> Continue From {{siteBatchPageHolder}}</button>
          <button class="btn btn-custom btn-blue batch-action-button" data-dismiss="modal" (click)="siteAssnBatchFn(1,'continue',20)"> Start Over</button>
          <button class="btn btn-custom btn-blue batch-action-button" type="button" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END Start for site assignment batch -->

<!-- START confirm start site batch on start -->
<div class="modal fade" id="showConfirmStartBatchOnStart" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Site Assignment Batch
          <button type="button" class="close" id="closeSiteStartBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              <span>
                Previously the batch was paused at page : <span class="label-orange font-weight-bold">{{siteBatchPageHolder}}</span>
              </span>
            </div>
            <div class="py-2">
              <span>
                Batch processing resumes in :<span class="font-weight-bold pl-1 page-number">{{timerForBatchStart}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal" (click)="stopSiteBatchAssnExe()"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END confirm start site batch on start -->

<!-- START show steps for sites creation-->
<div class="modal fade" id="showSiteCreationSteps" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Site Creation
          <button type="button" class="close" id="closeSiteCreationStepsModal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <ul class="row m-0 nav list-view p-0 pt-1">
              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold">
                  Field Validation -
                </span>
                <span>
                  <img src="assets/images/loading.gif" alt="loading..." *ngIf="!validationSuccess">
                  <span class="text-success" *ngIf="validationSuccess==true">Success</span>
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold">
                  City Selection -
                </span>
                <span [innerHtml]="citySelection">
                  <!-- <img src="assets/images/loading.gif" alt="loading..." *ngIf="citySelection=='loading'">
                  <span class="text-success" *ngIf="citySelection=='success'">Success</span>
                  <span class="text-success" *ngIf="citySelection=='created'">New City Created</span>
                  <span class="text-danger" *ngIf="citySelection=='error'">Error</span> -->
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold">
                  Site Creation -
                </span>
                <span [innerHtml]="siteCreation">
                  <!-- <img src="assets/images/loading.gif" alt="loading..." *ngIf="siteCreation=='loading'">
                  <span class="text-success" *ngIf="siteCreation=='success'">Success</span>
                  <span class="text-danger" *ngIf="siteCreation=='error'">Error</span> -->
                </span>
              </li>

              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold">
                  Access Point -
                </span>
                <span [innerHtml]="acpCreation">
                </span>
              </li>
              <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <span class="font-weight-bold">
                  New Site Created -
                </span>
                <span [innerHtml]="finalSiteCreation">
                </span>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END show steps for site creation -->

<!-- HIDDEN TABLE for site assignment batch -->
<div class="hidden-content">
  <table id="excelTableLog">
    <thead>
      <tr>
        <th>Company Name</th>
        <th>Company Identifier</th>
        <th>Company Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of tableDataForSiteAssnBatch">
        <td>
          {{allCompanyData[c] ? allCompanyData[c].legalName : '-'}}
        </td>
        <td>
          {{allCompanyData[c] ? allCompanyData[c].allianceIdentifier : '-'}}
        </td>
        <td>
          {{allCompanyData[c] ? allCompanyData[c].companyStatusCode : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- END site assignment batch -->

<!-- country info model starts here -->
<div class="modal fade mt-4" id="dispCountryInfo" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom"  role="document">
    <div class="modal-content country-modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Countries
          <button type="button" class="close" id="closeDispCountryInfo" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>
      <div class="modal-body row m-0 p-0 table-responsive modal-scroll-body">
        <table class="table m-0">

          <thead class="table-header-background">
            <tr class="col p-0">
              <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom" (click)="sort('countryFlag')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('countryFlag'))">Flag</th>
              <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom" (click)="sort('countryCode')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('countryCode'))">Code</th>
              <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 thCustom" (click)="sort('countryName')" tabindex="0" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (sort('countryName'))">Name</th>
            </tr>
          </thead>
          <tbody *ngIf="dataForDispCountryInfo.length>0">
            <tr *ngFor="let dats of dataForDispCountryInfo; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold"><img src="{{dats.flag}}" alt="info"></td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{dats.countryCode}}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold">{{dats.countryName}}</td>
            </tr>
          </tbody>
          <tbody *ngIf="dataForDispCountryInfo.length==0">
            <tr>
              <td colspan="7" class="font-weight-bold label-darkblue text-center">No Results</td>
            </tr>
          </tbody>
           <ng-container *ngIf="countryInfoLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
            <!-- Spinner -->
        </table>
      </div>
      <div class="modal-footer border-0 row">
        <section class="bg-white no-shadow m-0 row">
          <button type="button" class="btn btn-custom btn-blue btn-lg grpBtn" data-dismiss="modal" id="closeDispCountryInfo">
            Close
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- country info model ends here -->

<!-- START Factories code  modal -->
<div class="modal fade"  id="openFactoriesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content factories-modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
         Factories
          <button type="button" class="close" id="closeFactoriesModal" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body row m-0 p-0 table-responsive modal-scroll-body">
        <table class="table m-0">
          <thead class="table-header-background">
            <tr class="col p-0">
              <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 text-center label-darkblue label-orange thCustom sortDecorationunderline">Code</th>
              <th class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-4 text-center thCustom sortDecorationunderline">Name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let datsa of paginatedSites | orderBy: key:reverse; let i = index" class="col forColor p-0">
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-center factory-code">{{datsa.value }}</td>
              <td class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-6 tdCustom font-weight-bold text-center">{{datsa.label}}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td colspan="8" class="factory-pagination-cell">

                  <ul *ngIf="paginatedSites" class="pagination">
                    <li [ngClass]="{disabled:p === 1}">
                        <a (click)="onPageChange(1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onPageChange(1))">First</a>
                    </li>
                    <li [ngClass]="{disabled:p === 1}">
                        <a (click)="onPageChange(p - 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onPageChange(p - 1))">Previous</a>
                    </li>
                    <li *ngFor="let page of factPager.pages" [ngClass]="{active:p === page}">
                        <a (click)="onPageChange(page)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onPageChange(page))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:p === factPager.totalPages}">
                        <a (click)="onPageChange(p + 1)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onPageChange(p + 1))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:p === factPager.totalPages}">
                        <a (click)="onPageChange(paginatedSites.length)" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (onPageChange(paginatedSites.length))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
           <ng-container *ngIf="FactoriescodeLoading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
            <!-- Spinner -->

        </table>
      </div>
      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
           Cancel
          </button>&nbsp;&nbsp;
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
            Ok
           </button>
        </section>
      </div>
    </div>
  </div>
  </div>
 <!-- END Factories  code  modal -->

 <!-- START Upload Nissan codes -->
<div class="modal fade" id="showNissanCodeUploading" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Uploading Asusi Codes
          <button type="button" class="close" id="closeNissanCodeUploading" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="showDownloadLogForNissan==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForNissan()">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-orange">{{TextForCompleteUpload}}</span>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Close </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END Upload Nissan codes -->

<!-- HIDDEN TABLE for Upload Nissan codes -->
<div class="hidden-content">
  <table id="excelTableLogForNissan">
    <thead>
      <tr>
        <th>Error Message</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let indexRow of logFileArrayOfUploadErrors">
        <td>
          {{indexRow['error'] ? indexRow['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- END HIDDEN TABLE for Upload Nissan codes -->

<!-- START confirm start Add main entr batch on start -->
<div class="modal fade" id="showConfirmMainEntrStartBatch" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Add Main Entrance Batch
          <button type="button" class="close" id="closeMainEntrStartBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">
              <span>
                Previously the batch was paused at page : <span class="label-orange font-weight-bold">{{mainEntrBatchPageHolder}}</span>
              </span>
            </div>
            <div class="py-2">
              <span>
                Batch processing resumes in :<span class="font-weight-bold pl-1 page-number">{{timerForMainEntrBatchStart}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button type="button" class="btn btn-custom btn-blue" data-dismiss="modal" (click)="stopAddMainEntrBatch()"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END confirm start Add main entr batch on start -->

<!-- START Add main entr batch -->
<div class="modal fade" id="showMainEntrBatch" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Add Main Entrance Batch
          <button type="button" class="close" id="closeMainEntrBatch" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2" *ngIf="showDownloadLogForMainEntr==false">&nbsp;
              <span [innerHtml]="mainEntrTextDisp">
              </span>
            </div>
            <div class="py-2" *ngIf="showDownloadLogForMainEntr==true">
              <button class="btn btn-custom btn-blue" (click)="downloadLogFileForMAinEntr()">
                Download Log File
              </button>
            </div>
            <div class="py-2">
              <span class="label-orange">Processing page:</span>&nbsp;<span class="page-number">{{mainEntrpageBatchNo}}</span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-blue" (click)="changeStopBatchForMainEntr()"> Stop </button>
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END Add main entr batch -->

<!-- START Add Main Entrance Batch Alread RUN Batch-->
<div class="modal fade" id="showAlreadyRunMainEntrBatch" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Add Main Entrance Batch
          <button type="button" class="close" id="closeMainEntrBatchExistDia" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="py-2">&nbsp;
              <span>
                Previously the batch was stopped at page : <span class="label-orange font-weight-bold">{{mainEntrBatchPageHolder}}</span>
              </span>
            </div>
            <div>
            </div>
          </div>
        </section>
      </div>
      <div class="modal-footer border-0 col">
        <section class="bg-white no-shadow row">
          <button class="btn btn-custom btn-blue batch-continue-button" data-dismiss="modal" (click)="addMainEntBatchFn(mainEntrBatchPageHolder,'continue',20)"> Continue From {{mainEntrBatchPageHolder}}</button>
          <button class="btn btn-custom btn-blue batch-action-button" data-dismiss="modal" (click)="addMainEntBatchFn(1,'continue',20)"> Start Over</button>
          <button class="btn btn-custom btn-blue batch-action-button" type="button" data-dismiss="modal"> Cancel </button>
        </section>
      </div>
    </div>
  </div>
</div>
<!-- END Start for Add Main Entrance Batch Alread RUN Batch-->

<!-- HIDDEN TABLE for Add Main Entrance Batch-->
<div class="hidden-content">
  <table id="excelTableLogForMainEntr">
    <thead>
      <tr>
        <th>SITE IDENTIFIER</th>
        <th>ERROR</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of logFileArrayOfAddMainEntrErrors">
        <td>
          {{c['site'] ? c['site'] : '-'}}
        </td>
        <td>
          {{c['error'] ? c['error'] : '-'}}
        </td>
      </tr>
    </tbody>
  </table>
</div>
<!-- END Add Main Entrance Batch -->

<div class="modal fade"  id="openWarningNoGpsData" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-custom" role="document">
    <div class="modal-content warning-modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Warning
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <p class="font-weight-bold text-center h6">
              No City GPS data available
            </p>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0" >
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" data-dismiss="modal"> Ok </button>
        </section>
      </div>
    </div>
  </div>
</div>

<!-- Hidden Div for modal calls -->
<div class="hidden-content">
  <button id="btnForSiteContinue" data-target="#showAlreadyRunBatch" data-toggle="modal"></button>
  <button id="btnForSiteAssignmentBatch" data-target="#showSiteAssnBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmStartBatchOnStart" data-target="#showConfirmStartBatchOnStart" data-toggle="modal"></button>
  <button id="btnForSiteCreateSteps" data-target="#showSiteCreationSteps" data-toggle="modal"></button>
  <button id="btnForShowNissanCodeUploading" data-target="#showNissanCodeUploading" data-toggle="modal"></button>
  <button id="btnForMainEntrContinue" data-target="#showAlreadyRunMainEntrBatch" data-toggle="modal"></button>
  <button id="btnForMainEntrBatch" data-target="#showMainEntrBatch" data-toggle="modal"></button>
  <button id="BtnForshowConfirmMainEntrStartBatch" data-target="#showConfirmMainEntrStartBatch" data-toggle="modal"></button>
  <button id="btnForNoGpsData" data-target="#openWarningNoGpsData" data-toggle="modal"></button>
</div>
</div>